import React from "react";
import LocalStorage from "../../../util/localStorage";
import {getJWT} from "../../../util/util-auth";
import Env from "../../../../util/env";
import Resources from "../../../../data/services/resources";
import {getProp} from "../../../util/util-helpers";

const About = ({translate}) => {
    const user = LocalStorage.get('user');
    const token = getJWT().access_token;
    const ContactID = user?.Contact.ContactID;
    const CompanyName = user?.Contact.CompanyName;
    const commitHash = import.meta.env.VITE_COMMIT_HASH;

    const currentVersion = Env.getNpmPackageVersion();

    let compName = '';
    if (LocalStorage.has("user")) {
        compName = getProp(LocalStorage.get("user"), 'Contact.CompanyName', import.meta.env.VITE_PLATFORM_NAME ?? "ACCUR8 TMS");
    }

    return (
        <div className={'text-center pb-8'}>
            <div className={'bg-tm-gray-200 p-5'}>
                <img className={"h-16 m-auto mb-3 rounded-2xl"} src={Env.getApiUrl("api/" + Resources.CompanyImage, {
                    token: token,
                    ContactID: ContactID
                })}
                     alt={CompanyName}
                />
                <h1 className="text-2xl">{compName}</h1>
            </div>

            <div className={'mt-5 text-tm-gray-500 p-5'}>
                {translate("text.CurrentVersion")} - {currentVersion}
                {!!commitHash && (
                    <p>{translate("text.GitVersion")} - {commitHash}</p>
                )}
            </div>

            <p className="text-tm-gray-700">
                See the <a href="https://releases.accur8.services/" target="_blank"
                           rel="noopener noreferrer"
                           className="text-primary underline">release notes</a> for a
                full list of all changes from previous version.</p>
        </div>
    )
}

export default About
